var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post-failed",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("i", { staticClass: "fa-regular fa-circle-exclamation" }),
      _c("p", [_vm._v(_vm._s(_vm.textError))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }